import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const Link = ({
  className = '',
  href = '',
  title = '',
  target = '_self',
  nofollow = false,
  eventDataLayer,
  children,
  ...props
}) => {
  return (
        <a
            className={className}
            title={title}
            target={target}
            href={href}
            rel={`noopener noreferrer ${nofollow ? 'nofollow' : ''}`}
            // ยิง datalayer เฉพาะตอนได้รับ eventDataLayer ที่มี type จริง
            // กันเคสการ์ดที่ไม่ได้ส่ง eventDataLayer มา (เดิม <Link> จะยิงก้อนว่างทับของจริง = "คลิกแล้วไม่ได้ค่า")
            onClick={eventDataLayer?.type ? () => sendDataLayerGlobal({ ...eventDataLayer }) : undefined}
            {...props}
        >
            {children}
        </a>
  );
};

export default Link;
